import { useEffect } from "react";
import Footer from "../components/Footer.component";
import Navbar from "../components/Navbar.component";
import "./Error.page.css";

const Error = () => {
  useEffect(() => {
    document.title = "😟 404 | Drugstoc"
  })
  return (
    <>
      <Navbar />
      <div className="error-page">
        <h1 className="title">404</h1>
        <p className="subtitle">Oops! This page could not be found.</p>
      </div>
      <Footer />
    </>
  );
};

export default Error;
